module.exports = __webpack_public_path__ + "static/media/LG_U+_logo.13b0f78e.png";